export enum StepperItemTypes {
    default = 'Default',
    validation = 'Validation',
    confirmation = 'Confirmation'
}

export enum stepperItemImageType {
    none = 'none',
    success = 'success'
}

export enum StepperVersion {
    V3 = 'v3',
    V4 = 'v4',
    Compressed = 'Compressed',
    Full = 'Full'
}